
import { useNavigate } from "react-router-dom";

import Layout from '../../components/Layout/LoginLayout/LoginLayout';

import './style.css';


function ForgotPasswordSuccess(){

    const navigate = useNavigate();

    const redirectToLogin = () => {
        navigate("/Admin/Login");
    }

    return (

        <Layout>
                    
        <div className="" style={{marginRight:'10px', marginLeft:'10px'}}>

        <div className="font-green center-middle">
            <h1>
                Email Sent
            </h1>
        </div>
        <div style={{fontSize:'16px'}}>
            We have sent the password recovery instructions to your registered email.
        </div>
        <br />
        <br />

        <div>
            <br />
            <div className="center-middle">
                <button type="button" id="btnSignInPage" className="btn-green-100 center-middle" onClick={redirectToLogin}>Sign In</button>
            </div>
        </div>
        </div>

        </Layout>

    );

}


export default ForgotPasswordSuccess;